/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { bannerService } from './services'
import { addPopupAction } from './reducers/popup.reducer'
import { useNavigate } from 'react-router-dom'

import './assets/scss/theme.scss'
import { useQuery } from '@tanstack/react-query'

const App = () => {
  const navigate = useNavigate()
  window.dataLayer?.push({
    event: 'pageview',
  })
  let dispatch = useDispatch()
  // let { loggedIn } = useSelector((s) => s.authentication)
  // let [contentPages, setContentPages] = useState([])
  let [addAccessPopup, setAddAccessPopup] = useState(false)

  const { data: bannersResult, isFetched } = useQuery({
    queryKey: ['banners'],
    queryFn: bannerService.getAll(),
    staleTime: Infinity,
  })
  let banners = bannersResult?.data ?? []
  banners = banners.filter((r) => r.active && r.type === 'popup')
  // let hasBanner = banners.length > 0

  useEffect(() => {
    navigate('/admin', { replace: true })
  }, [])

  useEffect(() => {
    if (!addAccessPopup && isFetched) {
      var accessPopups = banners.filter((r) => r.event === 'ACCESS')
      if (accessPopups.length > 0) {
        dispatch(addPopupAction(accessPopups))
      }
      setAddAccessPopup(true)
    }
  }, [isFetched])

  return <></>
}

export default App
// export default hot(module)(App);
